const $ = require("jquery");

export default class {
  onCreate(input) {
    this.state = {
      ar1: "",
      ar2: "",
    };
  }

  onMount() {
    this.fetchPromise = Promise.resolve();
  }

  handleBeautifyJsonClick() {
    this.callJsonService("/json/beautify");
  }

  callJsonService(path) {
    const state = this.state;

    const str = this.getEl("ar1").value;
    this.state.ar1 = str;

    $.ajax({
      method: "POST", // added,
      url: path,
      contentType: "application/json",
      data: str,
      success: function (data) {
        // var ret = jQuery.parseJSON(data);
        // $('#lblResponse').html(ret.msg);
        state.ar2 = data;
      },
      error: function (xhr, status, error) {
        console.log(path + " json failed:", error);
        $("#lblResponse").html("Error connecting to the server.");
      },
    });
  }

  handleMinifyJsonClick() {
    this.callJsonService("/json/minify");
  }
};
